import { db } from './db';
import { auth } from './firebase';

/**
 * Fetches the providers row for the currently authenticated user via auth_user_id.
 * Fallback for places that can't use AppContext (utility modules, one-off async calls).
 * UI components should prefer useApp().currentProvider instead.
 *
 * §5 Auth — Identity Platform ONLY (Supabase session fallback removed 2026-07-06
 * after the post-cutover soak). auth_user_id is TEXT and holds the Firebase UID
 * (legacy users kept their original Supabase UUIDs as UIDs at import).
 */
export async function getCurrentProvider() {
  const uid = auth.currentUser?.uid || null;
  if (!uid) return null;

  // Everyone in the practice — clinicians, admins, and support staff (MA / front
  // desk / billing) — lives in the `providers` table with a `role`. Role resolves
  // here as long as the user has a login (auth_user_id set at invite time).
  const { data } = await db
    .from('providers')
    .select('id, first_name, last_name, email, role, requires_cosign')
    .eq('auth_user_id', uid)
    .single();

  return data ?? null;
}
